import React from 'react';
import { HistoryPickerItem } from './HistoryPickerItem';
import { FileText } from 'lucide-react';

export interface HistoryPickerProps {
  items: Array<{
    fileId: string;
    filename: string;
    displayName: string;
    agentName: string;
    timestamp: string | Date;
    sizeBytes: number;
  }>;
  activeIndex: number;
  onSelect: (item: any) => void;
  isLoading?: boolean;
}

export const HistoryPicker: React.FC<HistoryPickerProps> = ({
  items,
  activeIndex,
  onSelect,
  isLoading = false,
}) => {
  if (isLoading) {
    return (
      <div className="absolute bottom-[calc(100%+8px)] left-0 right-0 max-h-60 overflow-y-auto bg-white/70 dark:bg-surface-container-low/70 backdrop-blur-md rounded-2xl border border-outline-variant/30 shadow-xl py-4 flex items-center justify-center gap-2 z-50">
        <div className="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin" />
        <span className="text-xs text-secondary font-medium">Fetching history vault...</span>
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="absolute bottom-[calc(100%+8px)] left-0 right-0 max-h-60 overflow-y-auto bg-white/70 dark:bg-surface-container-low/70 backdrop-blur-md rounded-2xl border border-outline-variant/30 shadow-xl px-4 py-6 flex flex-col items-center justify-center gap-1.5 text-center z-50">
        <FileText className="w-6 h-6 text-secondary/40" />
        <h4 className="text-xs font-bold text-on-surface">No summaries found</h4>
        <p className="text-[10px] text-secondary/60 max-w-[240px]">
          Type more characters to search or generate a new summary from the toolbar first.
        </p>
      </div>
    );
  }

  return (
    <div className="absolute bottom-[calc(100%+8px)] left-0 right-0 max-h-60 overflow-y-auto bg-white/70 dark:bg-surface-container-low/70 backdrop-blur-md rounded-2xl border border-outline-variant/30 shadow-xl flex flex-col z-50 divide-y divide-outline-variant/10">
      {items.map((item, idx) => (
        <HistoryPickerItem
          key={item.fileId}
          item={item}
          isActive={idx === activeIndex}
          onClick={() => onSelect(item)}
        />
      ))}
    </div>
  );
};
